import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
const AchieveHero = () => {
  return (
    <>
      <div className="bg-achievement-bg bg-cover bg-center bg-no-repeat px-4">
        <div className="max-w-[1140px] mx-auto py-[242px] max-xl:py-44 max-lg:py-32 max-md:py-24 max-sm:py-14">
          <div className="max-w-[420px]">
            <BlueHeading
              text="Achievements "
              textClass="text-white"
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
              className="max-sm:justify-center"
            />
            <Heading
              children="Awards & Recognitions"
              className="text-white text-6xl max-sm:text-center pt-2"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AchieveHero;
